/**
 * Which account pages are opened, that is : shown as tab in header part of most pages.
 */

type RootReference = {
  type: 'root';
  id: string;
};

type PersonReference = {
  type: 'person';
  id: string;
  displayName: string; // to be able to display it without loading the person' data
};

export type AccountReference = RootReference | PersonReference;

export const equals = (ar1: AccountReference | undefined) => (ar2: AccountReference | undefined) =>
  ar1?.type === ar2?.type && ar1?.id === ar2?.id;

type Neighbors = [prev: AccountReference | undefined, prev: AccountReference | undefined];

/**
 * Given an OpenedAccountPageSpec and a list of such objects, will give the two pagespecs (prev and next) around the argument (or undefined if not found)
 * returns undefined for prev or next when boundaries are met
 */
export const neighbors = (
  accountRef: AccountReference,
  allOpenedAccountRefs: AccountReference[],
): Neighbors => {
  const pos = allOpenedAccountRefs.findIndex(equals(accountRef));
  if (pos < 0) {
    return [undefined, undefined];
  }
  return [
    allOpenedAccountRefs[pos - 1], // [...][-1] is undefined
    allOpenedAccountRefs[pos + 1], // [][1] is also undefined
  ];
};
